// Layouts
// ----------------
import AuthLayout from '@/views/Layout/AuthLayout.vue';
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

// General Views
// ----------------
import Forbidden from '@/views/GeneralViews/ForbiddenPage.vue';
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

// Pages
// ----------------
// Common
const Login = () => import(/* webpackChunkName: "common" */ '@/views/Pages/Auth/Login.page.vue');
const Activate = () => import(/* webpackChunkName: "common" */ '@/views/Pages/Auth/Activate.page.vue');
const ForgotPassword = () => import(/* webpackChunkName: "common" */ '@/views/Pages/Auth/ForgotPassword.page.vue');
const ResetPassword = () => import(/* webpackChunkName: "common" */ '@/views/Pages/Auth/ResetPassword.page.vue');

// Admin
const AdminDashboard = () => import(/* webpackChunkName: "admin" */ '@/views/Pages/Admin/AdminDashboard.vue');
const RetailerOverview = () => import(/* webpackChunkName: "admin" */ '@/views/Pages/Admin/RetailerOverview.vue');
const RetailerOnboarding = () => import(/* webpackChunkName: "admin" */ '@/views/Pages/Admin/RetailerOnboarding.vue');
const CharityOverview = () => import(/* webpackChunkName: "admin" */ '@/views/Pages/Admin/CharityOverview.vue');
const CharityOnboarding = () => import(/* webpackChunkName: "admin" */ '@/views/Pages/Admin/CharityOnboarding.vue');
const DropAnalyticsOperations = () => import(/* webpackChunkName: "admin" */ '@/views/Pages/Admin/DropAnalyticsOperations.vue');
const DropAnalyticsServiceImprovements = () => import(/* webpackChunkName: "admin" */ '@/views/Pages/Admin/DropAnalyticsServiceImprovements.vue');
const UserManagement = () => import(/* webpackChunkName: "admin" */ '@/views/Pages/Admin/UserManagement.vue');
const CreateDrop = () => import(/* webpackChunkName: "admin" */ '@/views/Pages/Admin/CreateDrop.vue');
const CreateVolunteer = () => import(/* webpackChunkName: "admin" */ '@/views/Pages/Admin/CreateVolunteer.vue');

// Retailer
const RetailerDashboard = () => import(/* webpackChunkName: "retailer" */ '@/views/Pages/Retailer/RetailerDashboard.vue');
const RetailerYourBranch = () => import(/* webpackChunkName: "retailer" */ '@/views/Pages/Retailer/RetailerYourBranch.vue');
const RetailerConnectedCharities = () => import(/* webpackChunkName: "retailer" */ '@/views/Pages/Retailer/RetailerConnectedCharities.vue');

// Retailer
const RetailerLeadDashboard = () => import(/* webpackChunkName: "retailerLead" */ '@/views/Pages/RetailerLead/RetailerLeadDashboard.vue');
const RetailerLeadChainManagement = () => import(/* webpackChunkName: "retailerLead" */ '@/views/Pages/RetailerLead/RetailerLeadChainManagement.vue');
const RetailerLeadBranchManagement = () => import(/* webpackChunkName: "retailerLead" */ '@/views/Pages/RetailerLead/RetailerLeadBranchManagement.vue');
const RetailerLeadConnectedCharities = () => import(/* webpackChunkName: "retailerLead" */ '@/views/Pages/RetailerLead/RetailerLeadConnectedCharities.vue');

// Charity
const CharityDashboard = () => import(/* webpackChunkName: "charity" */ '@/views/Pages/Charity/CharityDashboard.vue');
const CharityYourBranch = () => import(/* webpackChunkName: "charity" */ '@/views/Pages/Charity/CharityYourBranch.vue');
const CharityConnectedRetailers = () => import(/* webpackChunkName: "charity" */ '@/views/Pages/Charity/CharityConnectedRetailers.vue');


let dashboardRedirect = '/login';

let authPages = {
  path: '/auth',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/auth/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/auth/activate',
      name: 'Activate',
      component: Activate
    },
    {
      path: '/auth/forgot-password',
      name: 'Forgot Password',
      component: ForgotPassword
    },
    {
      path: '/auth/reset-password',
      name: 'Reset Password',
      component: ResetPassword
    },
    // 403
    { path: '/403', component: Forbidden },
    { path: '/*', component: NotFound }
  ]
};

const routes = [
  
  // Dashboards
  {
    path: '/',
    component: DashboardLayout,
    name: 'DashboardLayout',
    children: [
      {
        path: '/admin/dashboard',
        name: 'Admin Dashboard',
        component: AdminDashboard
      },
      {
        path: '/admin/retailer/overview',
        name: 'Retailer Overview',
        component: RetailerOverview
      },
      {
        path: '/admin/retailer/onboarding',
        name: 'Retailer Onboarding',
        component: RetailerOnboarding
      },
      {
        path: '/admin/charity/overview',
        name: 'Charity Overview',
        component: CharityOverview
      },
      {
        path: '/admin/charity/onboarding',
        name: 'Charity Onboarding',
        component: CharityOnboarding
      },
      {
        path: '/admin/drop/create',
        name: 'Create Drop',
        component: CreateDrop
      },
      {
        path: '/admin/volunteer/create',
        name: 'Create Volunteer',
        component: CreateVolunteer
      },
      {
        path: '/admin/users',
        name: 'User Management',
        component: UserManagement
      },
      {
        path: '/admin/drop-analytics/operations',
        name: 'Drop Analytics Operations',
        component: DropAnalyticsOperations
      },
      {
        path: '/admin/drop-analytics/service-improvements',
        name: 'Drop Analytics Service Improvements',
        component: DropAnalyticsServiceImprovements
      },
      {
        path: '/lead-retailer/dashboard',
        name: 'Retailer Lead Dashboard',
        component: RetailerLeadDashboard
      },
      {
        path: '/lead-retailer/chain-management',
        name: 'Retailer Lead Chain Management',
        component: RetailerLeadChainManagement
      },
      {
        path: '/lead-retailer/branch-management',
        name: 'Retailer Lead Branch Management',
        component: RetailerLeadBranchManagement
      },
      {
        path: '/lead-retailer/connected-charities',
        name: 'Retailer Lead Connected Charities',
        component: RetailerLeadConnectedCharities
      },
      {
        path: '/retailer/dashboard',
        name: 'Retailer Dashboard',
        component: RetailerDashboard
      },
      {
        path: '/retailer/your-branch',
        name: 'Retailer Your Branch',
        component: RetailerYourBranch
      },
      {
        path: '/retailer/connected-charities',
        name: 'Retailer Connected Charities',
        component: RetailerConnectedCharities
      },
      {
        path: '/charity/dashboard',
        name: 'Charity Dashboard',
        component: CharityDashboard
      },
      {
        path: '/charity/your-branch',
        name: 'Charity Your Branch',
        component: CharityYourBranch
      },
      {
        path: '/charity/connected-retailers',
        name: 'Charity Connected Retailers',
        component: CharityConnectedRetailers
      },
    ]
  },

  // Auth
  authPages,
];

export default routes;
